<template>
  <ion-content>
    <section class="section bg-gradient-animated novi-background p-sm-0"
             data-preset='{"title":"Intro","category":"intro","reload":false,"id":"intro-6"}'>
      <div class="container">
        <section class="section " style="margin-top: 0; padding-top: 1em">
          <div class="container">
            <!-- Breadcrumb-->
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link class="breadcrumb-link breadcrumb-active" to="/account/"><h5>My Account</h5></router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link class="breadcrumb-link" to="/opportunities/"><h5>Opportunities</h5></router-link>
              </li>
            </ul>
          </div>
        </section>
        <nav-links></nav-links>
      </div>
    </section>
  </ion-content>
</template>

<script>
import NavLinks from "@/account/pages/NavLinks";

export default {
  name: "login",
  components: {NavLinks}
}
</script>

<style scoped>

</style>
